export const retryAtInterval = (fn, condtion, interval = 500) => {
	const intervalID = setInterval(() => {
		if (condtion()) {
			clearInterval(intervalID);
		} else {
			fn();
		}
	}, interval);
};
